import { GlobalConfig } from "ngx-toastr";

export interface NotificationsModel {
	id: string;
	event: NotificationsEventModel;
	is_seen: boolean;
	seen_at: string;
	is_read: boolean;
	created_at: string;
	icon_name?: string;
	state?: NotificationState;
}

interface NotificationsEventModel {
	name: string;
	title: string;
	target_path?: NotificationTargets;
	subtitle: string;
}

export interface NotificationsCountModel {
	count: number;
}

export interface NotificationsIconModel {
	icon_name: string;
	name: string;
	state: NotificationState;
}

export enum NotificationState {
	success = "success",
	error = "error",
	warning = "warning",
	info = "info",
	neutral = "neutral"
}

export enum NotificationTargets {
	kyc_review = "/messages/kyc-review",
	verification_complete = "/messages/verification-complete",
	trade = "/messages/trade",
	email = "/messages/email",
	cash_plus_auto_roll = "/messages/cash-plus-auto-roll",
	payments_withdrawal = "/messages/payments-withdrawal",
	payments_deposit = "/messages/payments-deposit",
	weekly_best_payout = "/messages/weekly-best-payout",
	generic_wallet_transaction = "/messages/wallet/transaction",
	generic_fiat_wallet_transaction = "/messages/fiat-wallet/transaction",
	appropriateness_test = "/appropriateness-test",
	asset_details = "/asset",
	asset_buy = "/trade/buy",
	deposit = "/trade/deposit",
	proof_of_founds_upload = "/messages/proof-of-funds-upload",
	portfolio = "/portfolio",
	asset_sell = "/trade/sell",
	limit_order_page = "/trade/limit-order-list",
	anti_phishing_code = "/anti-phishing-code",
	watchlist_add = "/watchlist/add",
	watchlist_add_pa = "/watchlist/add-pa",
	crypto_deposit_validation = "/crypto-deposit-validation",
	crypto_deposit_verification = "/crypto-deposit/verification",
	crypto_withdrawal_verification = "/crypto-withdrawal/verification",
	user_report = "/user-report",
	web3_migration_start = "/nt-migration",
	limit_order_detail = "/trade/margin-order-details",
	tin = "/tin",
	kyc_refresh = "/kyc-refresh"
}

export interface BPGlobalConfig extends GlobalConfig {
	showAction?: boolean;
	actionMessage?: string;
}
